import React, { useState } from "react";
import "../Styles/Info.css";
import neurologyImage from '../Assets/How-Pediatric-Neurologists-Support-Children-with-Learning-and-Developmental-Disorders.jpg';
import strokeCareImage from '../Assets/Stroke-Patient.bmp';
import epilepsyImage from '../Assets/EpilepsyTreatment.png';
import parkinsonsImage from '../Assets/Parkinson\'s Disease Management.png';
import migrainesImage from '../Assets/Migraine Management.png';

function Info() {
  const [activeService, setActiveService] = useState("neurology");

  const services = {
    neurology: {
      name: "Neurology",
      title: "Advanced Neurology Care",
      description:
        "Our Neurology department is at the forefront of neurological medicine, offering comprehensive expertise in brain and nervous system disorders. We provide state-of-the-art diagnostics and innovative treatment solutions for complex neurological conditions.",
      procedures: [
        "STROKE MANAGEMENT",
        "EPILEPSY TREATMENT",
        "PARKINSON'S CARE"
      ],
      image: neurologyImage,
      buttons: [
        { text: "FIND DOCTOR", link: "#doctors" },
        { text: "EXPLORE MORE", link: "#specialties" }
      ]
    },
    strokecare: {
      name: "Stroke Care",
      title: "Stroke Care",
      description:
        "Our Stroke Care service is designed to be your reliable support in critical neurological situations. Whether it's a sudden stroke, migraine, or any neurological concern that requires immediate attention, our team of dedicated neurologists is available 24/7 to provide prompt and efficient care.",
      procedures: [
        "ACUTE STROKE THERAPY",
        "THROMBOLYTIC TREATMENT",
        "NEUROREHABILITATION"
      ],
      image: strokeCareImage,
      buttons: [
        { text: "FIND DOCTOR", link: "#doctors" },
        { text: "EXPLORE MORE", link: "#specialties" }
      ]
    },
    epilepsy: {
      name: "Epilepsy",
      title: "Epilepsy Treatment",
      description:
        "Our team of experienced neurologists and medical experts use state-of-the-art technology to assess your neurological health and design personalized treatment plans. From comprehensive screenings to advanced interventions, we are committed to helping you manage epilepsy and lead a fulfilling life.",
      procedures: [
        "EEG MONITORING",
        "ANTI-SEIZURE THERAPY",
        "EPILEPSY SURGERY"
      ],
      image: epilepsyImage,
      buttons: [
        { text: "FIND DOCTOR", link: "#doctors" },
        { text: "EXPLORE MORE", link: "#specialties" }
      ]
    },
    parkinsons: {
      name: "Parkinson's",
      title: "Parkinson's Disease Management",
      description:
        "Specialized care for Parkinson's patients as our Neurology services cater to all your neurological health needs. Our skilled neurologists provide a wide range of treatments, from routine check-ups and therapy to advanced procedures and restorative treatments.",
      procedures: [
        "MOVEMENT DISORDER TREATMENT",
        "DEEP BRAIN STIMULATION",
        "PHYSICAL THERAPY"
      ],
      image: parkinsonsImage,
      buttons: [
        { text: "FIND DOCTOR", link: "#doctors" },
        { text: "EXPLORE MORE", link: "#specialties" }
      ]
    },
    migraines: {
      name: "Migraines",
      title: "Migraine Management",
      description:
        "Comprehensive migraine diagnosis and treatment services designed to reduce frequency and intensity of attacks. Our expert neurologists provide personalized management strategies including preventive care, acute treatments, and lifestyle modifications.",
      procedures: [
        "MIGRAINE PROPHYLAXIS",
        "BOTOX INJECTIONS",
        "NERVE BLOCKS"
      ],
      image: migrainesImage,
      buttons: [
        { text: "FIND DOCTOR", link: "#doctors" },
        { text: "EXPLORE MORE", link: "#specialties" }
      ]
    },
    dementia: {
      name: "Dementia",
      title: "Dementia & Memory Disorders",
      description:
        "Expert diagnosis and management of dementia and cognitive disorders with early detection programs and personalized treatment plans. Our compassionate team provides ongoing support for patients and families navigating memory disorders.",
      procedures: [
        "COGNITIVE ASSESSMENT",
        "NEUROIMAGING",
        "MEMORY REHABILITATION"
      ],
      image: "https://images.unsplash.com/photo-1631217314831-dc20da191959?w=600&h=400&fit=crop",
      buttons: [
        { text: "FIND DOCTOR", link: "#doctors" },
        { text: "EXPLORE MORE", link: "#specialties" }
      ]
    }
  };

  const service = services[activeService];

  return (
    <div className="info-section" id="services">
      <div className="info-container">
        {/* Header */}
        <div className="info-header">
          <h3 className="info-title">
            <span>Discover Our Neurology Services</span>
          </h3>
          <p className="info-subtitle">
            Experience world-class neurological healthcare at our specialized neurology center. Our state-of-the-art facilities deliver unparalleled expertise in brain and nervous system disorders. Each service stands as a beacon of cutting-edge care, setting new benchmarks in neurological treatment globally.
          </p>
        </div>

        {/* Service Tabs */}
        <div className="info-tabs">
          {Object.entries(services).map(([key, svc]) => (
            <button
              key={key}
              className={`info-tab ${activeService === key ? "active" : ""}`}
              onClick={() => setActiveService(key)}
            >
              {svc.name}
            </button>
          ))}
          <button className="info-tab more-tab">
            <span className="plus-icon">+</span>
          </button>
        </div>

        {/* Service Content */}
        <div className="info-content">
          {/* Left Content */}
          <div className="info-text-content">
            <h2 className="info-content-title">{service.title}</h2>
            <p className="info-content-description">{service.description}</p>

            {/* Procedures */}
            <div className="info-procedures">
              <h4 className="procedures-title">Top Services & Procedures</h4>
              <div className="procedures-list">
                {service.procedures.map((proc, index) => (
                  <p key={index} className="procedure-item">{proc}</p>
                ))}
              </div>
            </div>

            {/* Buttons */}
            <div className="info-actions">
              {service.buttons.map((btn, index) => (
                <a key={index} href={btn.link} className="info-btn">
                  {btn.text} <span className="arrow">→</span>
                </a>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="info-image-content">
            <img
              src={service.image}
              alt={service.title}
              className={`info-image ${activeService === 'migraines' ? 'migraine-image' : ''}`}
            />
          </div>
        </div>

        {/* Navigation Arrows */}
        <button 
          className="nav-arrow left-arrow" 
          onClick={() => {
            const keys = Object.keys(services);
            const currentIndex = keys.indexOf(activeService);
            setActiveService(keys[(currentIndex - 1 + keys.length) % keys.length]);
          }}
        >
          ←
        </button>
        <button 
          className="nav-arrow right-arrow"
          onClick={() => {
            const keys = Object.keys(services);
            const currentIndex = keys.indexOf(activeService);
            setActiveService(keys[(currentIndex + 1) % keys.length]);
          }}
        >
          →
        </button>
      </div>
    </div>
  );
}

export default Info;
